import React from 'react';
import { 
  FaPhone, 
  FaEnvelope, 
  FaUserPlus,
  FaUserCircle 
} from 'react-icons/fa';

const TopHeader = () => {
  return (
    <header className="bg-red-600 py-2 topHeader">
      <div className="container mx-auto px-4">
        <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center space-y-2 sm:space-y-0">
          <div className="flex flex-col sm:flex-row sm:space-x-6 space-y-2 sm:space-y-0 text-sm">
            <a 
              href="tel:+55-4XX-634-7071" 
              className="flex items-center text-white hover:text-gray-200 transition-colors"
            >
              <FaPhone className="mr-2 text-xs" />
              <span className="hidden sm:inline mr-2">Need Support? </span> 0487-233-1069
            </a>
            <a 
              href="mailto:info@themevessel.com" 
              className="flex items-center text-white hover:text-gray-200 transition-colors"
            >
              <FaEnvelope className="mr-2 text-xs" />
              ilfk2025@gmail.com
            </a>
          </div>
          <div className="flex space-x-3 sm:space-x-4 text-sm">
            {/* <a 
              href="/login" 
              className="flex items-center text-white hover:text-gray-200 transition-colors"
            >
              <FaUserCircle className="mr-1 sm:mr-2 text-xs" />
              Login
            </a>
            <a 
              href="/register" 
              className="flex items-center text-white hover:text-gray-200 transition-colors"
            >
              <FaUserPlus className="mr-1 sm:mr-2 text-xs" />
              Register
            </a> */}
          </div>
        </div>
      </div>
    </header>
  );
};

export default TopHeader;
